/* global SUPABASE_URL, SUPABASE_ANON_KEY */
const BASE = SUPABASE_URL;
const KEY  = SUPABASE_ANON_KEY;

function headers() {
  return {
    apikey: KEY,
    Authorization: `Bearer ${KEY}`,
    'Content-Type': 'application/json',
  };
}

export async function recordResult(itemId, won) {
  try {
    const r = await fetch(`${BASE}/rest/v1/rpc/record_item_result`, {
      method: 'POST',
      headers: headers(),
      body: JSON.stringify({ p_item_id: String(itemId), p_won: won }),
    });
    if (!r.ok) return null;
    const rows = await r.json();
    return rows[0] || null;
  } catch {
    return null;
  }
}
